<template>
    <div class="md-layout md-gutter mt-4">
      <div class="md-layout-item md-size-100 md-small-size-100 mt-4">
        <div class="md-layout-item md-size-100">
            <form ref="password_form">
                <md-card style="box-shadow:none">

                    <md-card-header class="md-card-header-icon md-card-header-primary">
                    <div class="card-icon">
                        <md-icon>lock_reset</md-icon>
                    </div>
                    <h2 class="title" style="font-weight:bold!important">
                        Reset Password
                    </h2>
                    </md-card-header>

                    <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                        <md-field class="md-invalid">
                            <label>Email</label>
                            <md-input v-model="email" type="email"/>
                        </md-field>
                        </div>
                    </div>
                    </md-card-content>

                </md-card>

                </form>
        </div>
        <md-card-actions>
          <md-button @click="sendLink">
            Send Link
          </md-button>
        </md-card-actions>
      </div>
    </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";

export default {

  components: {
  },
  mixins: [formMixin],

  data: () => ({
        email: ""
  }),

  methods: {
    async sendLink() {
      try {
        await this.$store.dispatch("users/resetPassword", this.email)
        await this.$store.dispatch("alerts/success", "Link sent successfully.")
      } catch (e) {
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }

    },
  },
};
</script>
